import { NavLink, useLocation } from 'react-router-dom';
import {
  LayoutDashboard,
  Briefcase,
  Building2,
  UserCircle,
  LogOut,
} from 'lucide-react';
import { useAuth } from '@zaogig/auth';

const navItems = [
  { title: '企业控制台', icon: LayoutDashboard, path: '/' },
  { title: '数据概览', icon: Briefcase, path: '/dashboard' },
  { title: '任务管理', icon: Building2, path: '/jobs' },
  { title: '企业中心', icon: UserCircle, path: '/profile' },
];

export function EnterpriseSidebar() {
  const { user, logout } = useAuth();
  const location = useLocation();

  return (
    <aside className="flex h-screen w-64 flex-col border-r border-slate-200 bg-white">
      {/* Brand */}
      <div className="flex h-16 items-center gap-2 border-b border-slate-100 px-5">
        <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-indigo-600 font-black text-white">
          Z
        </div>
        <span className="text-lg font-bold tracking-tight text-slate-900">早知企业</span>
      </div>

      {/* Nav */}
      <nav className="flex-1 space-y-1 px-3 py-4">
        {navItems.map((item) => {
          const isActive = item.path === '/'
            ? location.pathname === '/' || location.pathname === '/enterprise'
            : location.pathname.startsWith(item.path);

          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-colors ${
                isActive
                  ? 'bg-indigo-50 text-indigo-600'
                  : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'
              }`}
            >
              <item.icon className="h-5 w-5" />
              {item.title}
            </NavLink>
          );
        })}
      </nav>

      {/* User info + logout */}
      <div className="border-t border-slate-100 p-4">
        <div className="mb-2 text-xs text-slate-400">
          {user ? `${user.currentRole === 'employer' ? '企业用户' : '管理员'}` : '未登录'}
        </div>
        <button
          onClick={logout}
          className="flex w-full items-center gap-2 rounded-xl px-3 py-2 text-sm font-medium text-slate-600 transition-colors hover:bg-red-50 hover:text-red-600"
        >
          <LogOut className="h-4 w-4" />
          退出登录
        </button>
      </div>
    </aside>
  );
}
